import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Color,
  Header,
  Hyperlink,
  Paragraph
} from '@eggplant/pattern-library'
import {
  SYSTEM,
  WEBHOOK
} from '@eggplant/routing'
import { daiWebhooks } from '../../docs-routes'
import type { CSSProperties } from 'react'

const wrapperStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  rowGap: '16px'
}

const WebhookProfileFieldDescription = () =>
  <div style={wrapperStyle}>
    <div>
      <Header
        hasNoTopMargin
        rank={4}
      >
        Webhook profile
      </Header>
      <Paragraph>
        <Color
          display='inline'
          variant='theme-description-text'
        >
          Webhook profiles are where you configure webhook notifications, including the messaging app you want to use and the notification payload. DAI admins can create a webhook profile on the
          {' '}
          <Hyperlink
            href={`/${SYSTEM}/${WEBHOOK}`}
            isExternal
          >
            Webhooks
          </Hyperlink>
          {' '}
          page.
        </Color>
      </Paragraph>
    </div>
    <div>
      <LinkToDocusaurus path={daiWebhooks}>
        Learn more in the DAI documentation
      </LinkToDocusaurus>
    </div>
  </div>

export default WebhookProfileFieldDescription
